import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const uuid = require('uuid');

const Strings = require("../../../../../app/shared/Strings");
const ActivityStore = require('../../../stores/activity_store_reflux');
const ProjectStore = require('../../../stores/ProjectStore');
const ActivityActions = require('../../../actions/ActivityActions');
import Tooltip from '../../common/Tooltip';
import SortableTable2 from '../../table/SortableTable2';
import { TagNameInfo } from './OrgMetaTagInfoWarnings';

const propTypes = {
    orgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    typeRecord: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        type_display_name: PropTypes.string.isRequired,
        user_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }).isRequired,
    className: PropTypes.string,
    onDelete: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

const defaultProps = {
    className: '',
};

class OrgActMetaTypeEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newTypeName: null,
            actsForType: ActivityStore.getState().metaTypesToActivities[props.typeRecord.id] || [],
        };

        this.refreshActsForType = this.refreshActsForType.bind(this);
        this.onChangeTypeName = this.onChangeTypeName.bind(this);
        this.onUpdateTypeName = this.onUpdateTypeName.bind(this)
        this.unsubscribes = [
            ActivityStore.listen(this.onActivityStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        this.refreshActsForType(this.props.orgId, this.props.typeRecord.id);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.typeRecord.id !== this.props.typeRecord.id) {
            this.setState({ newTypeName: null }, () => {
                this.refreshActsForType(this.props.orgId, this.props.typeRecord.id);
            });
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onActivityStoreChange(newState) {
        this.setState({
            actsForType: newState.metaTypesToActivities[this.props.typeRecord.id] || [],
        });
    }

    refreshActsForType(orgId, typeId) {
        ActivityActions.getActivitiesForMetaType(
            uuid.v4(),
            {
                orgId: orgId,
                typeId: typeId,
            }
        );
    }

    onChangeTypeName(e) {
        this.setState({ newTypeName: e.target.value });
    }

    onUpdateTypeName() {
        if (!this.state.newTypeName) return;
        this.props.onUpdate(this.state.newTypeName);
    }

    render() {
        const self = this;
        const typeNameToEdit = typeof this.state.newTypeName === 'string' ? this.state.newTypeName : this.props.typeRecord.type_display_name;

        return (
            <div className={`${this.props.className}`}>
                <h3 className="large-heading-regular">
                    {Strings['en'].act_meta_types.ACTIVITY_TYPE}: <strong className="font-weight-bold">{this.props.typeRecord.type_display_name}</strong>
                </h3>
                <hr className="medium hr-color-6" />
                <div className="margin-top-lg">
                    <h4>{Strings['en'].common.EDIT}</h4>
                    <hr className="small hr-color-6"/>
                    <Form className="padding-tb-md">
                        <Form.Group controlId={`new-tag-name-${this.props.typeRecord.id}`}>
                            <Form.Label>{Strings['en'].act_meta_types.TYPE_DISPLAY_NAME}</Form.Label>
                            <Tooltip id={`org-atype-tt-${this.props.typeRecord.id}`} className="margin-left-sm" placement="right">
                                <TagNameInfo />
                            </Tooltip>
                            <InputGroup>
                                <Form.Control
                                    value={typeNameToEdit}
                                    onChange={this.onChangeTypeName}
                                />
                                <InputGroup.Append>
                                    <Button 
                                        disabled={!this.state.newTypeName || typeNameToEdit === this.props.typeRecord.type_display_name}
                                        onClick={this.onUpdateTypeName}
                                    >
                                        {Strings['en'].common.UPDATE}
                                    </Button>
                                </InputGroup.Append>
                            </InputGroup>
                        </Form.Group>
                    </Form>
                    <div className="padding-tb-md fl">
                        <Button variant="danger" onClick={this.props.onDelete}>
                            {Strings['en'].act_meta_types.DELETE_TYPE}
                        </Button>
                    </div>
                    <div className="padding-tb-md fr">
                        <Button onClick={this.props.onClose}>
                            {Strings['en'].common.STOP_EDITING}
                        </Button>
                    </div>
                    <div className="float-clear" />
                </div>
                <div className="margin-top-lg">
                    <h4>{Strings['en'].act_meta_types.ACTS_W_ATTACHED}</h4>
                    <hr className="small hr-color-6"/>
                    {(this.state.actsForType.length > 0) ?
                        <SortableTable2
                            classNameTable="font-size-md padding-tb-md"
                            hideSearch
                            showTotal={false}
                            uniqueRowKey="activity_id"
                            rowsPerPage={10}
                            rows={this.state.actsForType}
                            dateFormat="YYYY-MM-DD HH:mm z"
                            defaultSort={{ key:'date_attached', type:'date', asc: false }}
                            columns={[
                                {
                                    displayName: Strings['en'].activity.ACTIVITY_NAME,
                                    key: 'activity_id',
                                    type: 'int',
                                    sortable: false,
                                },
                                {
                                    displayName: Strings['en'].project.PROJECT,
                                    key: 'project_id',
                                    type: 'int',
                                    sortable: false,
                                },
                                {
                                    displayName: Strings['en'].act_meta_tags.DATE_ATTACHED,
                                    key: 'date_attached',
                                    type: 'date',
                                }
                            ]}
                            displayColumnCallbacks={{
                                'activity_id': (actId) => {
                                    const actRecord = self.state.actsForType.find(act => act.activity_id === actId);
                                    let activityName = `${Strings['en'].activity.ACTIVITY} ${actRecord.activity_id}`; // if for some reason the activity store doesn't have the act
                                    const actStoreState = ActivityStore.getStateActivity(actRecord.activity_id, actRecord.project_id, actRecord.channel_id);
                                    if (
                                        actStoreState.initialized
                                        && !!actStoreState.activity
                                    ) {
                                        activityName = actStoreState.activity.meta_data.title;
                                    }

                                    return (
                                        <Link
                                            to={`/project/${actRecord.channel_id}/${actRecord.project_id}/activity/${actRecord.activity_id}/meta_tags#category-act-type`}
                                            target="_blank"
                                        >
                                            {activityName}
                                        </Link>
                                    );
                                },
                                'project_id': (projId) => {
                                    let projectName = `${Strings['en'].project.PROJECT} ${projId}`;
                                    const projectStoreState = ProjectStore.getStateProject(projId);
                                    if (
                                        projectStoreState.initialized
                                        && projectStoreState.project
                                    ) {
                                        projectName = projectStoreState.project.name;
                                    }

                                    return projectName;
                                }
                            }}
                        />
                        :
                        Strings['en'].common.NONE
                    }
                </div>
            </div>
        );
    }
}

OrgActMetaTypeEditor.propTypes = propTypes;
OrgActMetaTypeEditor.defaultProps = defaultProps;

export default OrgActMetaTypeEditor;